import {Directive, Attribute, ElementRef, DynamicComponentLoader} from 'angular2/core';
import {Router, RouterOutlet, ComponentInstruction} from 'angular2/router';
import {JwtHelper} from 'angular2-jwt';

@Directive({
  selector: 'router-outlet'
})
export class LoggedInRouterOutlet extends RouterOutlet {
  publicRoutes: any;
  private parentRouter: Router;

  constructor(_elementRef: ElementRef, _loader: DynamicComponentLoader,
    _parentRouter: Router, @Attribute('name') nameAttr: string) {
    super(_elementRef, _loader, _parentRouter, nameAttr);

    this.parentRouter = _parentRouter;
    this.publicRoutes = {
      '/admin/users/login': true,
      '/admin/users/signup': true,
    };
  }

  activate(instruction: ComponentInstruction) {
    var url = this.parentRouter.lastNavigationAttempt;
    if (this.needsAuth(url) && !this.validJwt()) {
      this.parentRouter.navigateByUrl('/admin/users/login');
    }
    return super.activate(instruction);
  }

  private needsAuth(url: string): boolean {
    return (url.startsWith('/admin') && !this.publicRoutes[url]);
  }

  private validJwt(): boolean {
    let jwt = localStorage.getItem('jwt');
    if (!jwt) {
      return false;
    }
    let helper = new JwtHelper();
    return !helper.isTokenExpired(jwt);
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/app/LoggedInOutlet.ts
 **/